// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guest-amount-input_wrapper__StFJA","labels":"guest-amount-input_labels__Suar4","label":"guest-amount-input_label__pxgsH","subLabel":"guest-amount-input_subLabel__W5bmQ"};